/**
 * Kapadia Kraft - 1-Step WhatsApp Checkout Drawer Engine (Ultra-Premium Edition)
 * Intercepts checkout actions, validates Indian fields, creates real Shopify order,
 * commits stock, records packing slip, and redirects directly to WhatsApp.
 */
(function() {
  'use strict';

  if (window.__KK_DRAWER_LOADED__) return;
  window.__KK_DRAWER_LOADED__ = true;

  var API_ORDER_URL = 'https://kapadiakraft-checkout.vercel.app/api/create-order';
  var WA_PHONE = '919499539960';
  var SLIP_BASE_URL = 'https://kapadiakraft.com/pages/order-slip';
  var FLAT_SHIPPING = 100.00;

  var currentCart = null;
  var isSubmitting = false;

  // Clean SVG Icons for ultra-premium luxury feel
  var ICONS = {
    cart: '<svg class="kk-sec-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>',
    user: '<svg class="kk-sec-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
    mapPin: '<svg class="kk-sec-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="12" height="12"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="15" height="15"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
    whatsapp: '<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18" style="vertical-align: middle;"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="32" height="32"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>'
  };

  // Indian States & Union Territories
  var INDIAN_STATES = [
    "Gujarat",
    "Maharashtra",
    "Rajasthan",
    "Madhya Pradesh",
    "Delhi",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Jammu and Kashmir",
    "Ladakh",
    "Lakshadweep",
    "Puducherry"
  ];

  // Helper: Format INR
  function formatINR(val) {
    var n = parseFloat(val) || 0;
    return '₹' + n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // Base64 URL safe encoder
  function encodeBase64Url(obj) {
    try {
      var str = JSON.stringify(obj);
      var b64 = btoa(unescape(encodeURIComponent(str)));
      return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    } catch(e) {
      return '';
    }
  }

  // Fetch Cart Object from Shopify Storefront (Cache-Busted)
  function fetchCart(callback) {
    var cacheBustUrl = '/cart.js?t=' + Date.now();
    return fetch(cacheBustUrl, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache'
      },
      cache: 'no-store'
    })
      .then(function(res) {
        if (!res.ok) throw new Error('Cart fetch failed with status ' + res.status);
        return res.json();
      })
      .then(function(cart) {
        currentCart = cart;
        if (callback) callback(cart);
        if (isDrawerOpen()) {
          if (!cart || !cart.items || cart.items.length === 0) {
            renderEmptyCart();
          } else {
            renderCartSummary(cart);
          }
        }
        return cart;
      })
      .catch(function(err) {
        console.error('[KK] Cart fetch error:', err);
        if (callback) callback(currentCart || { items: [], total_price: 0, item_count: 0 });
      });
  }

  // Inject Drawer Markup into DOM
  function injectDrawerMarkup() {
    if (document.getElementById('kk-checkout-drawer-root')) return;

    var stateOptions = INDIAN_STATES.map(function(s) {
      var selected = (s === 'Gujarat') ? ' selected' : '';
      return '<option value="' + s + '"' + selected + '>' + s + '</option>';
    }).join('');

    var html = '' +
    '<div id="kk-checkout-drawer-root" aria-hidden="true">' +
      '<div id="kk-drawer-overlay"></div>' +
      '<div id="kk-drawer-panel" role="dialog" aria-modal="true" aria-label="1-Step Checkout Drawer">' +
        
        '<!-- Drawer Header -->' +
        '<div class="kk-drawer-header">' +
          '<div class="kk-drawer-title-group">' +
            '<div class="kk-drawer-badge-icon">' + ICONS.cart + '</div>' +
            '<div>' +
              '<h2 class="kk-drawer-title">1-Step Checkout</h2>' +
              '<p class="kk-drawer-subtitle">Direct WhatsApp Payment • Kapadia Kraft</p>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="kk-drawer-close-btn" id="kk-close-drawer-btn" aria-label="Close Checkout">' + ICONS.close + '</button>' +
        '</div>' +

        '<!-- Drawer Body -->' +
        '<div class="kk-drawer-body">' +

          '<!-- Order Summary Card -->' +
          '<div class="kk-section-card">' +
            '<div class="kk-section-header">' +
              '<h3 class="kk-section-title">' + ICONS.cart + ' Order Summary</h3>' +
              '<span id="kk-summary-count" style="font-size: 11px; font-weight: 700; color: #64748b;">0 items</span>' +
            '</div>' +
            '<div class="kk-items-list" id="kk-summary-items"></div>' +
            '<div class="kk-price-row">' +
              '<span>Items Subtotal</span>' +
              '<strong id="kk-summary-subtotal">₹0.00</strong>' +
            '</div>' +
            '<div class="kk-price-row">' +
              '<span>Delivery <span class="kk-shipping-badge">Standard approx</span></span>' +
              '<strong>₹100.00</strong>' +
            '</div>' +
            '<div class="kk-price-row kk-price-total">' +
              '<span>Total Amount</span>' +
              '<span id="kk-summary-total" style="color: #15803d; font-size: 16px; font-weight: 800;">₹100.00</span>' +
            '</div>' +
          '</div>' +

          '<!-- Customer Details Form -->' +
          '<form id="kk-checkout-form" novalidate>' +
            '<div class="kk-section-card">' +
              '<div class="kk-section-header">' +
                '<h3 class="kk-section-title">' + ICONS.user + ' Customer Details</h3>' +
              '</div>' +

              '<!-- Name Fields -->' +
              '<div class="kk-form-grid">' +
                '<div class="kk-field-group">' +
                  '<label class="kk-field-label" for="kk-first-name">First Name <span class="req">*</span></label>' +
                  '<input type="text" id="kk-first-name" class="kk-input" placeholder="e.g. Rahul" autocomplete="given-name" autocapitalize="words" required>' +
                  '<div class="kk-field-error" id="err-kk-first-name">First name is required</div>' +
                '</div>' +
                '<div class="kk-field-group">' +
                  '<label class="kk-field-label" for="kk-last-name">Last Name <span class="req">*</span></label>' +
                  '<input type="text" id="kk-last-name" class="kk-input" placeholder="e.g. Sharma" autocomplete="family-name" autocapitalize="words" required>' +
                  '<div class="kk-field-error" id="err-kk-last-name">Last name is required</div>' +
                '</div>' +
              '</div>' +

              '<!-- WhatsApp Phone -->' +
              '<div class="kk-field-group" style="margin-bottom: 12px;">' +
                '<label class="kk-field-label" for="kk-phone">WhatsApp Number <span class="req">*</span></label>' +
                '<div class="kk-phone-wrapper">' +
                  '<span class="kk-phone-prefix">+91</span>' +
                  '<input type="tel" id="kk-phone" class="kk-input kk-phone-input" placeholder="10-digit mobile" maxlength="10" inputmode="tel" autocomplete="tel-national" required>' +
                '</div>' +
                '<div class="kk-field-error" id="err-kk-phone">Valid 10-digit Indian WhatsApp number required</div>' +
                '<small style="font-size: 11px; color: #64748b; margin-top: 3px;">Payment QR code and order bill will be sent to this WhatsApp.</small>' +
              '</div>' +

              '<!-- Email Address -->' +
              '<div class="kk-field-group">' +
                '<label class="kk-field-label" for="kk-email">Email Address <span class="req">*</span></label>' +
                '<input type="email" id="kk-email" class="kk-input" placeholder="rahul@gmail.com" autocomplete="email" autocapitalize="none" spellcheck="false" required>' +
                '<div class="kk-field-error" id="err-kk-email">Valid email format required (e.g. name@domain.com)</div>' +
              '</div>' +
            '</div>' +

            '<!-- Delivery Address -->' +
            '<div class="kk-section-card">' +
              '<div class="kk-section-header">' +
                '<h3 class="kk-section-title">' + ICONS.mapPin + ' Delivery Address</h3>' +
              '</div>' +

              '<div class="kk-field-group" style="margin-bottom: 12px;">' +
                '<label class="kk-field-label" for="kk-address1">Address Line 1 / Street / Flat / House <span class="req">*</span></label>' +
                '<input type="text" id="kk-address1" class="kk-input" placeholder="House/Flat No., Building Name, Street" autocomplete="address-line1" autocapitalize="words" required>' +
                '<div class="kk-field-error" id="err-kk-address1">Address line 1 is required</div>' +
              '</div>' +

              '<div class="kk-field-group" style="margin-bottom: 12px;">' +
                '<label class="kk-field-label" for="kk-address2">Address Line 2 / Landmark <span style="font-weight: normal; color: #94a3b8;">(Optional)</span></label>' +
                '<input type="text" id="kk-address2" class="kk-input" placeholder="Nearby landmark, suite, floor" autocomplete="address-line2" autocapitalize="words">' +
              '</div>' +

              '<div class="kk-form-grid">' +
                '<div class="kk-field-group">' +
                  '<label class="kk-field-label" for="kk-zip">PIN Code <span class="req">*</span></label>' +
                  '<input type="text" id="kk-zip" class="kk-input" placeholder="6-digit PIN" maxlength="6" inputmode="numeric" pattern="[0-9]*" autocomplete="postal-code" required>' +
                  '<div class="kk-field-error" id="err-kk-zip">Valid 6-digit Indian PIN required</div>' +
                '</div>' +
                '<div class="kk-field-group">' +
                  '<label class="kk-field-label" for="kk-city">City <span class="req">*</span></label>' +
                  '<input type="text" id="kk-city" class="kk-input" placeholder="City / District" autocomplete="address-level2" autocapitalize="words" required>' +
                  '<div class="kk-field-error" id="err-kk-city">City is required</div>' +
                '</div>' +
              '</div>' +

              '<div class="kk-field-group">' +
                '<label class="kk-field-label" for="kk-state">State / Province <span class="req">*</span></label>' +
                '<select id="kk-state" class="kk-select" autocomplete="address-level1" required>' +
                  stateOptions +
                '</select>' +
                '<div class="kk-field-error" id="err-kk-state">State is required</div>' +
              '</div>' +

              '<!-- Country & Delivery Method -->' +
              '<div class="kk-form-grid" style="margin-top: 12px; margin-bottom: 0;">' +
                '<div class="kk-field-group">' +
                  '<label class="kk-field-label">Country / Region</label>' +
                  '<div style="height: 44px; display: flex; align-items: center; padding: 0 13px; background: #f8fafc; border: 1px solid #cbd5e1; border-radius: 8px; font-size: 13px; font-weight: 600; color: #334155;">' +
                    '<span>India</span>' +
                  '</div>' +
                '</div>' +
                '<div class="kk-field-group">' +
                  '<label class="kk-field-label">Shipping Method</label>' +
                  '<div style="height: 44px; display: flex; align-items: center; justify-content: space-between; padding: 0 13px; background: #f8fafc; border: 1px solid #cbd5e1; border-radius: 8px; font-size: 12.5px; font-weight: 600; color: #334155;">' +
                    '<span>Standard approx</span>' +
                    '<span style="color: #15803d; font-weight: 700;">₹100.00</span>' +
                  '</div>' +
                '</div>' +
              '</div>' +

              '<!-- Order Notes / Delivery Instructions -->' +
              '<div class="kk-field-group" style="margin-top: 12px;">' +
                '<label class="kk-field-label" for="kk-order-note">Order Notes / Delivery Instructions <span style="font-weight: normal; color: #94a3b8;">(Optional)</span></label>' +
                '<textarea id="kk-order-note" class="kk-input" style="height: 56px; padding: 8px 12px; resize: none; font-family: inherit;" placeholder="Special packing, delivery instructions, or landmark details"></textarea>' +
              '</div>' +

              '<!-- Save Delivery Information for next time -->' +
              '<div style="margin-top: 12px; display: flex; align-items: center; gap: 8px;">' +
                '<input type="checkbox" id="kk-save-profile" checked="checked" style="accent-color: var(--kk-primary); width: 16px; height: 16px; cursor: pointer;">' +
                '<label for="kk-save-profile" style="font-size: 12px; color: #475569; cursor: pointer; user-select: none;">Save this information for next time</label>' +
              '</div>' +
            '</div>' +

            '<!-- Payment Method Box -->' +
            '<div class="kk-payment-card">' +
              '<input type="radio" class="kk-payment-radio" checked="checked" readOnly id="kk-pay-qr">' +
              '<div class="kk-payment-info">' +
                '<h4 class="kk-payment-title">' +
                  '<span>Pre-Paid via WhatsApp QR</span>' +
                  '<span class="kk-payment-chip">UPI / Cards</span>' +
                '</h4>' +
                '<p class="kk-payment-desc">' +
                  'Pay via Google Pay, PhonePe, Paytm, or UPI. Instant payment QR code and digital invoice sent directly on WhatsApp.' +
                '</p>' +
              '</div>' +
            '</div>' +

            '<!-- Video Unboxing Notice -->' +
            '<div class="kk-unboxing-notice">' +
              '<div class="kk-unboxing-icon">' +
                '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m22 8-6 4 6 4V8Z"/><rect width="14" height="12" x="2" y="6" rx="2" ry="2"/></svg>' +
              '</div>' +
              '<div class="kk-unboxing-text">' +
                '<strong>Important:</strong> Record video before opening the product to claim any issue.' +
              '</div>' +
            '</div>' +

          '</form>' +
        '</div>' +

        '<!-- Drawer Footer -->' +
        '<div class="kk-drawer-footer">' +
          '<button type="button" class="kk-submit-btn" id="kk-place-order-btn">' +
            '<span id="kk-btn-icon">' + ICONS.whatsapp + '</span>' +
            '<span id="kk-btn-text">Place Order &amp; Pay via WhatsApp</span>' +
          '</button>' +
          '<div class="kk-trust-row">' +
            ICONS.lock +
            '<span>Official Store</span>' +
            '<span class="kk-trust-dot">•</span>' +
            '<span>Flat ₹100 Shipping</span>' +
            '<span class="kk-trust-dot">•</span>' +
            '<span>Direct Support</span>' +
          '</div>' +
        '</div>' +

      '</div>' +
    '</div>';

    var div = document.createElement('div');
    div.innerHTML = html;
    document.body.appendChild(div.firstElementChild);

    // Bind event listeners
    bindDrawerEvents();
    loadSavedCustomer();
  }

  function bindDrawerEvents() {
    var overlay = document.getElementById('kk-drawer-overlay');
    var closeBtn = document.getElementById('kk-close-drawer-btn');
    var submitBtn = document.getElementById('kk-place-order-btn');

    if (overlay) overlay.onclick = closeDrawer;
    if (closeBtn) closeBtn.onclick = closeDrawer;
    if (submitBtn) submitBtn.onclick = handleOrderSubmit;

    // Real-time input validation clearers
    ['kk-first-name', 'kk-last-name', 'kk-phone', 'kk-email', 'kk-address1', 'kk-zip', 'kk-city', 'kk-state'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) {
        el.addEventListener('input', function() {
          validateField(id, true);
        });
      }
    });

    // Clean phone number to digits only
    var phoneEl = document.getElementById('kk-phone');
    if (phoneEl) {
      phoneEl.addEventListener('input', function() {
        this.value = this.value.replace(/[^0-9]/g, '').slice(0, 10);
      });
    }

    // Clean zip code to digits only
    var zipEl = document.getElementById('kk-zip');
    if (zipEl) {
      zipEl.addEventListener('input', function() {
        this.value = this.value.replace(/[^0-9]/g, '').slice(0, 6);
      });
    }

    // Keyboard ESC to close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isDrawerOpen()) {
        closeDrawer();
      }
    });
  }

  function isDrawerOpen() {
    var root = document.getElementById('kk-checkout-drawer-root');
    return root && root.classList.contains('kk-active');
  }

  function showDrawerRoot() {
    var root = document.getElementById('kk-checkout-drawer-root');
    if (root) {
      root.classList.add('kk-active');
      root.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }

  function renderEmptyCart() {
    var itemsContainer = document.getElementById('kk-summary-items');
    var countEl = document.getElementById('kk-summary-count');
    var formEl = document.getElementById('kk-checkout-form');
    var footerEl = document.querySelector('.kk-drawer-footer');

    if (countEl) countEl.innerText = '0 items';
    if (itemsContainer) {
      itemsContainer.innerHTML = '' +
        '<div style="text-align: center; padding: 32px 14px;">' +
          '<div style="width: 52px; height: 52px; border-radius: 50%; background: #f8fafc; border: 1px solid #e2e8f0; display: flex; align-items: center; justify-content: center; margin: 0 auto 12px auto; color: #94a3b8;">' +
            ICONS.cart +
          '</div>' +
          '<h4 style="margin: 0 0 6px 0; font-size: 15px; font-weight: 700; color: #0f172a;">Your cart is empty</h4>' +
          '<p style="margin: 0 0 16px 0; font-size: 12.5px; color: #64748b; line-height: 1.45;">Add handcrafted items to your bag before checking out.</p>' +
          '<button type="button" onclick="window.KapadiaKraftCheckout.close()" style="background: #0f172a; color: #ffffff; border: none; border-radius: 8px; padding: 10px 22px; font-size: 13px; font-weight: 600; cursor: pointer; transition: all 0.15s ease;">Continue Shopping</button>' +
        '</div>';
    }
    if (formEl) formEl.style.display = 'none';
    if (footerEl) footerEl.style.display = 'none';
  }

  function openDrawer() {
    injectDrawerMarkup();
    fetchCart(function(cart) {
      if (!cart || !cart.items || cart.items.length === 0) {
        renderEmptyCart();
        showDrawerRoot();
        return;
      }

      renderCartSummary(cart);

      // Populate note if cart already had a note
      if (currentCart && currentCart.note) {
        var noteInput = document.getElementById('kk-order-note');
        if (noteInput && !noteInput.value) {
          noteInput.value = currentCart.note;
        }
      }

      // Close native cart drawer if open
      try {
        var nativeDrawers = document.querySelectorAll('cart-drawer, .cart-drawer, cart-drawer-component, dialog[id*="cart"], [id*="cart-drawer"], dialog.cart-drawer__dialog, dialog.dialog-drawer');
        nativeDrawers.forEach(function(d) {
          if (typeof d.close === 'function') d.close();
          if (typeof d.closeDialog === 'function') d.closeDialog();
          if (d.hasAttribute('open')) d.removeAttribute('open');
        });
      } catch(e) {}

      showDrawerRoot();
    });
  }

  function closeDrawer() {
    var root = document.getElementById('kk-checkout-drawer-root');
    if (root) {
      root.classList.remove('kk-active');
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  function renderCartSummary(cart) {
    var formEl = document.getElementById('kk-checkout-form');
    var footerEl = document.querySelector('.kk-drawer-footer');
    if (formEl) formEl.style.display = '';
    if (footerEl) footerEl.style.display = '';

    var itemsContainer = document.getElementById('kk-summary-items');
    var countEl = document.getElementById('kk-summary-count');
    var subtotalEl = document.getElementById('kk-summary-subtotal');
    var totalEl = document.getElementById('kk-summary-total');
    var btnText = document.getElementById('kk-btn-text');

    if (!itemsContainer) return;

    var subtotal = (cart.total_price / 100.0);
    var total = subtotal + FLAT_SHIPPING;

    if (countEl) countEl.innerText = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    if (subtotalEl) subtotalEl.innerText = formatINR(subtotal);
    if (totalEl) totalEl.innerText = formatINR(total);
    if (btnText) btnText.innerHTML = 'Place Order &amp; Pay via WhatsApp • ' + formatINR(total);

    var itemsHtml = '';
    cart.items.forEach(function(it) {
      var img = it.featured_image ? (it.featured_image.url || it.image) : '';
      var vTitle = it.variant_title;
      if (vTitle && ['default', 'default title', 'none', 'null'].indexOf(vTitle.toLowerCase().trim()) !== -1) {
        vTitle = '';
      }
      var unitPrice = (it.price / 100.0);
      var lineTotal = (it.line_price / 100.0);

      var propsHtml = '';
      if (it.properties && typeof it.properties === 'object') {
        var pKeys = Object.keys(it.properties);
        if (pKeys.length > 0) {
          var validBadges = [];
          pKeys.forEach(function(pk) {
            var pv = it.properties[pk];
            if (pv && !pk.startsWith('_')) {
              var strVal = String(pv).trim();
              if (strVal !== '' && ['null', 'undefined', 'none'].indexOf(strVal.toLowerCase()) === -1) {
                validBadges.push('<div style="font-size: 11px; color: #475569; display: flex; align-items: center; gap: 4px;"><span style="font-weight: 700; color: #0f172a;">' + pk + ':</span> <span style="color: #991b1b; font-weight: 600;">' + strVal + '</span></div>');
              }
            }
          });
          if (validBadges.length > 0) {
            propsHtml = '<div style="margin-top: 4px; display: flex; flex-direction: column; gap: 2px;">' + validBadges.join('') + '</div>';
          }
        }
      }

      itemsHtml += '' +
      '<div class="kk-summary-item">' +
        (img ? '<img src="' + img + '" class="kk-item-thumb" alt="' + (it.title || '') + '">' : '<div class="kk-item-thumb"></div>') +
        '<div class="kk-item-info">' +
          '<div class="kk-item-title">' + (it.title || 'Product') + '</div>' +
          (vTitle ? '<div class="kk-item-var">' + vTitle + '</div>' : '') +
          propsHtml +
          '<div style="font-size: 11.5px; color: #64748b; margin-top: 2px;">Qty: ' + it.quantity + ' &times; ' + formatINR(unitPrice) + '</div>' +
        '</div>' +
        '<div class="kk-item-price-qty">' + formatINR(lineTotal) + '</div>' +
      '</div>';
    });

    itemsContainer.innerHTML = itemsHtml;
  }

  // Field Validation
  function validateField(id, silent) {
    var el = document.getElementById(id);
    var errEl = document.getElementById('err-' + id);
    if (!el) return true;

    var val = (el.value || '').trim();
    var isValid = true;

    if (id === 'kk-first-name' || id === 'kk-last-name') {
      isValid = val.length >= 1;
    } else if (id === 'kk-phone') {
      var clean = val.replace(/[^0-9]/g, '');
      isValid = clean.length === 10 && /^[6-9]\d{9}$/.test(clean);
    } else if (id === 'kk-email') {
      isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
    } else if (id === 'kk-address1') {
      isValid = val.length >= 3;
    } else if (id === 'kk-zip') {
      isValid = val.length === 6 && /^[1-9][0-9]{5}$/.test(val);
    } else if (id === 'kk-city') {
      isValid = val.length >= 2;
    } else if (id === 'kk-state') {
      isValid = val.length >= 2;
    }

    if (!isValid) {
      if (!silent) {
        el.classList.add('kk-input-error');
        if (errEl) errEl.classList.add('show');
      }
    } else {
      el.classList.remove('kk-input-error');
      if (errEl) errEl.classList.remove('show');
    }

    return isValid;
  }

  function validateAllFields() {
    var fields = ['kk-first-name', 'kk-last-name', 'kk-phone', 'kk-email', 'kk-address1', 'kk-zip', 'kk-city', 'kk-state'];
    var allValid = true;
    var firstInvalidEl = null;

    fields.forEach(function(f) {
      var ok = validateField(f, false);
      if (!ok) {
        allValid = false;
        if (!firstInvalidEl) firstInvalidEl = document.getElementById(f);
      }
    });

    if (firstInvalidEl) {
      firstInvalidEl.focus();
      try {
        firstInvalidEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch(e) {}
    }

    return allValid;
  }

  // Save / Load Customer Data in localStorage
  function saveCustomerData(cust, addr) {
    try {
      var data = { customer: cust, address: addr };
      localStorage.setItem('kk_customer_profile', JSON.stringify(data));
    } catch(e) {}
  }

  function loadSavedCustomer() {
    try {
      var raw = localStorage.getItem('kk_customer_profile');
      if (!raw) return;
      var data = JSON.parse(raw);
      if (data.customer) {
        if (data.customer.first_name) document.getElementById('kk-first-name').value = data.customer.first_name;
        if (data.customer.last_name) document.getElementById('kk-last-name').value = data.customer.last_name;
        if (data.customer.phone) document.getElementById('kk-phone').value = data.customer.phone;
        if (data.customer.email) document.getElementById('kk-email').value = data.customer.email;
      }
      if (data.address) {
        if (data.address.address1) document.getElementById('kk-address1').value = data.address.address1;
        if (data.address.address2) document.getElementById('kk-address2').value = data.address.address2;
        if (data.address.city) document.getElementById('kk-city').value = data.address.city;
        if (data.address.zip) document.getElementById('kk-zip').value = data.address.zip;
        if (data.address.province) document.getElementById('kk-state').value = data.address.province;
      }
    } catch(e) {}
  }

  // Handle Order Placement & WhatsApp Redirect
  function handleOrderSubmit(e) {
    if (e) e.preventDefault();
    if (isSubmitting) return;

    if (!validateAllFields()) {
      return;
    }

    if (!currentCart || !currentCart.items || currentCart.items.length === 0) {
      renderEmptyCart();
      return;
    }

    var firstName = document.getElementById('kk-first-name').value.trim();
    var lastName = document.getElementById('kk-last-name').value.trim();
    var phone = document.getElementById('kk-phone').value.trim().replace(/[^0-9]/g, '');
    var email = document.getElementById('kk-email').value.trim();
    var address1 = document.getElementById('kk-address1').value.trim();
    var address2 = (document.getElementById('kk-address2').value || '').trim();
    var zip = document.getElementById('kk-zip').value.trim();
    var city = document.getElementById('kk-city').value.trim();
    var state = document.getElementById('kk-state').value;

    var customerPayload = {
      first_name: firstName,
      last_name: lastName,
      phone: phone,
      email: email
    };

    var shippingPayload = {
      address1: address1,
      address2: address2,
      city: city,
      province: state,
      zip: zip
    };

    var noteEl = document.getElementById('kk-order-note');
    var noteVal = noteEl ? (noteEl.value || '').trim() : '';
    if (!noteVal && currentCart && currentCart.note) {
      noteVal = currentCart.note.trim();
    }

    var saveProfileEl = document.getElementById('kk-save-profile');
    if (!saveProfileEl || saveProfileEl.checked) {
      saveCustomerData(customerPayload, shippingPayload);
    }

    var itemsPayload = currentCart.items.map(function(it) {
      var img = it.featured_image ? (it.featured_image.url || it.image) : '';
      return {
        variant_id: it.variant_id || it.id,
        quantity: it.quantity,
        title: it.title,
        price: (it.price / 100.0),
        image: img,
        properties: it.properties || {}
      };
    });

    var submitBtn = document.getElementById('kk-place-order-btn');
    var btnIcon = document.getElementById('kk-btn-icon');
    var btnText = document.getElementById('kk-btn-text');

    isSubmitting = true;
    if (submitBtn) submitBtn.disabled = true;
    if (btnIcon) btnIcon.innerHTML = '<span class="kk-spinner"></span>';
    if (btnText) btnText.innerHTML = 'Registering Order &amp; Generating Bill...';

    var requestBody = {
      customer: customerPayload,
      shipping_address: shippingPayload,
      note: noteVal,
      items: itemsPayload
    };

    fetch(API_ORDER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody)
    })
    .then(function(res) {
      return res.json().then(function(data) {
        return { status: res.status, ok: res.ok, data: data };
      });
    })
    .then(function(result) {
      if (!result.ok || !result.data.success) {
        throw new Error(result.data.error || 'Failed to create order in Shopify.');
      }

      var resData = result.data;
      var orderNumber = resData.order_number;
      var totalPrice = parseFloat(resData.total_price || (resData.order_payload && resData.order_payload.total) || 0).toFixed(2);
      var customerName = resData.customer_name || (firstName + ' ' + lastName);
      var customerPhone = resData.customer_phone || phone;

      var customerAddress = (resData.order_payload && resData.order_payload.shipping_address) ||
        [address1, address2, city, (state ? (state + (zip ? (' — ' + zip) : '')) : zip), 'India'].filter(Boolean).join(', ');

      // 1. Save order to localStorage for instant client-side packing slip rendering
      try {
        if (resData.order_payload) {
          localStorage.setItem('kk_slip_' + orderNumber, JSON.stringify(resData.order_payload));
          localStorage.setItem('kk_last_order', orderNumber);
        }
      } catch(e) {}

      // 2. Construct WhatsApp Message URL
      var slipUrl = SLIP_BASE_URL + '?order=' + encodeURIComponent(orderNumber);

      var waMessage = "Hi KapadiaKraft! I have placed an order on your store.\n\n" +
        "🧾 Order ID: #" + orderNumber + "\n" +
        "💰 Total Amount: ₹" + totalPrice + "\n" +
        "👤 Customer: " + customerName + (customerPhone ? (" (📞 " + customerPhone + ")") : "") + "\n" +
        (customerAddress ? ("📍 addr: " + customerAddress + "\n\n") : "\n") +
        "📄 View Full Bill / Packing Slip:\n" +
        slipUrl + "\n\n" +
        "*Please send me the qr code to proceed for the payment!!*\n\n" +
        "📹 *Note:* Record video before opening the product to claim any issue.";

      var waLink = "https://wa.me/" + WA_PHONE + "?text=" + encodeURIComponent(waMessage);

      if (btnText) btnText.innerHTML = 'Redirecting to WhatsApp...';

      // 3. Render celebratory confirmation in drawer before redirecting
      try {
        var drawerBody = document.querySelector('.kk-drawer-body');
        var drawerFooter = document.querySelector('.kk-drawer-footer');
        if (drawerBody) {
          drawerBody.innerHTML = '' +
            '<div class="kk-success-screen">' +
              '<div class="kk-success-icon-wrap">' + ICONS.check + '</div>' +
              '<h3 class="kk-success-title">Order #' + orderNumber + ' Confirmed</h3>' +
              '<p class="kk-success-desc">Opening WhatsApp now to deliver your payment QR code and official bill...</p>' +
              '<div class="kk-unboxing-notice" style="margin: 0 auto 20px auto; max-width: 360px; text-align: left;">' +
                '<div class="kk-unboxing-icon">' +
                  '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m22 8-6 4 6 4V8Z"/><rect width="14" height="12" x="2" y="6" rx="2" ry="2"/></svg>' +
                '</div>' +
                '<div class="kk-unboxing-text">' +
                  '<strong>Important:</strong> Record video before opening the product to claim any issue.' +
                '</div>' +
              '</div>' +
              '<a href="' + waLink + '" class="kk-submit-btn" style="text-decoration: none; max-width: 340px; margin: 0 auto; display: flex; align-items: center; justify-content: center; gap: 8px;">' +
                ICONS.whatsapp +
                '<span>Open WhatsApp to Complete Payment</span>' +
              '</a>' +
            '</div>';
        }
        if (drawerFooter) drawerFooter.style.display = 'none';
      } catch(e) {}

      // 4. CLEAR LOCAL STATES IMMEDIATELY (so user can place another fresh order)
      currentCart = { items: [], item_count: 0, total_price: 0 };
      try {
        var noteInput = document.getElementById('kk-order-note');
        if (noteInput) noteInput.value = '';
        var itemsContainer = document.getElementById('kk-summary-items');
        if (itemsContainer) itemsContainer.innerHTML = '';
        var countEl = document.getElementById('kk-summary-count');
        if (countEl) countEl.innerText = '0 items';
        var subtotalEl = document.getElementById('kk-summary-subtotal');
        if (subtotalEl) subtotalEl.innerText = '₹0.00';
        var totalEl = document.getElementById('kk-summary-total');
        if (totalEl) totalEl.innerText = '₹0.00';

        // Clear custom inputs on PDP if still on the page
        var pdpName = document.querySelector('input[id*="kk-input-name"]');
        if (pdpName) pdpName.value = '';
        var pdpDate = document.querySelector('input[id*="kk-input-date"]');
        if (pdpDate) {
          pdpDate.value = '';
          pdpDate.removeAttribute('name');
        }

        // Notify theme components that cart is cleared
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { cart: currentCart } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: currentCart } }));
        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: currentCart } }));
      } catch(e) {}

      // 5. Clear Cart on Shopify Server and AWAIT completion before redirecting
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
      .catch(function(clearErr) {
        console.warn('[KK] Cart clear error:', clearErr);
      })
      .finally(function() {
        isSubmitting = false;
        // Redirect to WhatsApp
        window.location.href = waLink;
      });
    })
    .catch(function(err) {
      console.error('[KK] Order submission error:', err);
      isSubmitting = false;
      if (submitBtn) submitBtn.disabled = false;
      if (btnIcon) btnIcon.innerHTML = ICONS.whatsapp;
      if (btnText) btnText.innerHTML = 'Place Order &amp; Pay via WhatsApp';

      var errContainer = document.getElementById('kk-submit-error');
      if (!errContainer) {
        errContainer = document.createElement('div');
        errContainer.id = 'kk-submit-error';
        errContainer.className = 'kk-error-banner';
        var footer = document.querySelector('.kk-drawer-footer');
        if (footer) footer.insertBefore(errContainer, footer.firstChild);
      }
      errContainer.innerHTML = 'Unable to complete order. Please check your network or <a href="https://wa.me/' + WA_PHONE + '" target="_blank" style="color: inherit; font-weight: 700; text-decoration: underline;">message us on WhatsApp</a>.';
      errContainer.style.display = 'block';
    });
  }

  // Fast Buy Now Helper for Product Pages (Supports Custom Fields)
  window.kkBuyNow = function(btn) {
    // 1. Validate custom fields if present on product page
    if (typeof window.__validateCustomFields === 'function') {
      if (!window.__validateCustomFields()) {
        return false;
      }
    }

    var form = btn ? btn.closest('form') : null;
    if (!form || !form.querySelector('[name="id"]')) {
      form = document.querySelector('form.shopify-product-form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    }

    var variantId = null;
    if (form) {
      var idField = form.querySelector('[name="id"]');
      if (idField) variantId = idField.value;
    }
    if (!variantId) {
      var idField = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (idField) variantId = idField.value;
    }

    var qty = 1;
    if (form) {
      var qtyField = form.querySelector('[name="quantity"]');
      if (qtyField) qty = parseInt(qtyField.value, 10) || 1;
    }

    // 2. Bulletproof collection of line item properties (e.g. Name, Date)
    var properties = {};
    
    // Explicit direct query for custom fields by ID on PDP
    var nameInp = document.querySelector('input[id*="kk-input-name"]');
    if (nameInp && nameInp.value && nameInp.value.trim()) {
      properties['Name'] = nameInp.value.trim();
    }
    var dateInp = document.querySelector('input[id*="kk-input-date"]');
    if (dateInp && dateInp.value && dateInp.value.trim()) {
      properties['Date'] = dateInp.value.trim();
    }

    // Collect any other form properties
    var propInputs = [];
    if (form) {
      propInputs = propInputs.concat(Array.from(form.querySelectorAll('[name^="properties["]')));
    }
    var customWrap = document.querySelector('.kk-custom-fields-wrapper');
    if (customWrap) {
      propInputs = propInputs.concat(Array.from(customWrap.querySelectorAll('[name^="properties["]')));
    }

    propInputs.forEach(function(inp) {
      var match = inp.name.match(/^properties\[(.*?)\]$/);
      if (match && match[1] && inp.value) {
        var cleanVal = inp.value.trim();
        if (cleanVal !== '' && ['null', 'undefined', 'none'].indexOf(cleanVal.toLowerCase()) === -1) {
          properties[match[1]] = cleanVal;
        }
      }
    });

    if (!variantId) {
      openDrawer();
      return;
    }

    var originalText = '';
    if (btn) {
      btn.disabled = true;
      originalText = btn.innerHTML;
      btn.innerHTML = '<span class="button-text"><span class="kk-spinner" style="width:14px;height:14px;border-width:2px;margin-right:6px;vertical-align:middle;"></span>Adding...</span>';
    }

    var payload = { id: variantId, quantity: qty };
    if (Object.keys(properties).length > 0) {
      payload.properties = properties;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      openDrawer();
    })
    .catch(function(err) {
      console.error('[KK] Buy now error:', err);
      openDrawer();
    })
    .finally(function() {
      if (btn) {
        btn.disabled = false;
        if (originalText) btn.innerHTML = originalText;
      }
    });
  };

  // Quick Customisation Modal for Slideshow and Collection Cards
  window.openCustomiseModal = function(data) {
    if (!data) return;
    var modalRoot = document.getElementById('kk-custom-modal-root');
    if (!modalRoot) {
      modalRoot = document.createElement('div');
      modalRoot.id = 'kk-custom-modal-root';
      document.body.appendChild(modalRoot);
    }

    modalRoot.innerHTML = '' +
    '<div class="kk-cm-backdrop" onclick="window.closeCustomiseModal()">' +
      '<div class="kk-cm-dialog" onclick="event.stopPropagation()">' +
        '<div class="kk-cm-header">' +
          '<div style="display: flex; align-items: center; gap: 8px;">' +
            '<span class="kk-cm-badge">Bespoke Inscription</span>' +
          '</div>' +
          '<button type="button" class="kk-cm-close" onclick="window.closeCustomiseModal()" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="kk-cm-product-preview">' +
          (data.imgUrl ? '<img src="' + data.imgUrl + '" class="kk-cm-thumb" alt="' + (data.title || '') + '">' : '') +
          '<div>' +
            '<h4 class="kk-cm-prod-title">' + (data.title || 'Personalised Creation') + '</h4>' +
            '<div class="kk-cm-prod-price">' + (data.price || '') + '</div>' +
          '</div>' +
        '</div>' +
        '<p class="kk-cm-desc">Enter your customisation details below. Supports any language / script (English, اردو, عربي, हिंदी, ગુજરાતી, संस्कृत).</p>' +
        '<div class="kk-cm-form">' +
          '<div class="kk-cm-field">' +
            '<label class="kk-cm-label" for="kk-modal-name">Names / Inscription Text <span style="color:#dc2626;">*</span></label>' +
            '<input type="text" id="kk-modal-name" class="kk-cm-input" dir="auto" placeholder="e.g. Farhan & Rehana / فرحان و ريحانة" autocomplete="off" required>' +
            '<div class="kk-cm-error" id="kk-modal-err-name">Please enter name(s) for customisation</div>' +
          '</div>' +
          '<div class="kk-cm-field" style="margin-top: 12px;">' +
            '<label class="kk-cm-label" for="kk-modal-date">Event / Nikah Date <span style="font-size: 11px; font-weight: normal; color: #64748b; margin-left: 4px;">(Optional)</span></label>' +
            '<input type="date" id="kk-modal-date" class="kk-cm-input kk-cm-date">' +
          '</div>' +
          '<div style="margin-top: 18px;">' +
            '<button type="button" id="kk-modal-confirm-btn" class="kk-cm-btn-submit">' +
              '<span>Confirm &amp; Order via WhatsApp</span>' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';

    modalRoot.style.display = 'block';
    document.body.style.overflow = 'hidden';

    var confirmBtn = document.getElementById('kk-modal-confirm-btn');
    var inputName = document.getElementById('kk-modal-name');
    var inputDate = document.getElementById('kk-modal-date');
    var errName = document.getElementById('kk-modal-err-name');
    var errDate = document.getElementById('kk-modal-err-date');

    if (confirmBtn) {
      confirmBtn.onclick = function() {
        var nameVal = (inputName ? inputName.value : '').trim();
        var dateVal = (inputDate ? inputDate.value : '').trim();
        var hasErr = false;

        if (!nameVal) {
          hasErr = true;
          if (inputName) inputName.classList.add('is-invalid');
          if (errName) errName.style.display = 'block';
        } else {
          if (inputName) inputName.classList.remove('is-invalid');
          if (errName) errName.style.display = 'none';
        }

        if (hasErr) return;

        confirmBtn.disabled = true;
        confirmBtn.innerHTML = '<span class="kk-spinner" style="width:14px;height:14px;border-width:2px;margin-right:6px;vertical-align:middle;"></span>Adding...';

        var itemProps = { 'Name': nameVal };
        if (dateVal) {
          itemProps['Date'] = dateVal;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: data.variantId,
            quantity: 1,
            properties: itemProps
          })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          window.closeCustomiseModal();
          openDrawer();
        })
        .catch(function(err) {
          console.error('[KK] Modal add error:', err);
          window.closeCustomiseModal();
          openDrawer();
        });
      };
    }
  };

  window.closeCustomiseModal = function() {
    var modalRoot = document.getElementById('kk-custom-modal-root');
    if (modalRoot) {
      modalRoot.style.display = 'none';
      modalRoot.innerHTML = '';
      document.body.style.overflow = '';
    }
  };

  // Listen for Shopify theme cart update events to keep drawer synchronized
  var cartEventNames = ['cart:update', 'cart:change', 'cart:updated', 'cart:refresh', 'shopify:cart:update'];
  cartEventNames.forEach(function(evt) {
    document.addEventListener(evt, function(e) {
      if (isDrawerOpen()) {
        fetchCart(function(cart) {
          if (!cart || !cart.items || cart.items.length === 0) {
            renderEmptyCart();
          } else {
            renderCartSummary(cart);
          }
        });
      }
    });
  });

  // Intercept Checkout Actions across the Store
  function initCheckoutInterceptors() {
    injectDrawerMarkup();

    var isAddButton = function(el) {
      if (!el) return false;
      var name = el.getAttribute ? (el.getAttribute('name') || '') : (el.name || '');
      if (name === 'add') return true;
      if (el.classList) {
        if (el.classList.contains('add-to-cart-button') ||
            el.classList.contains('quick-add__button') ||
            el.classList.contains('product-form__submit') ||
            el.classList.contains('sticky-add-to-cart__button')) {
          return true;
        }
      }
      if (el.getAttribute && (
        el.getAttribute('data-testid') === 'standalone-add-to-cart' ||
        el.getAttribute('data-action') === 'add-to-cart' ||
        el.getAttribute('data-add-to-cart') !== null
      )) {
        return true;
      }
      return false;
    };

    var isCheckoutTrigger = function(target) {
      if (!target || !target.closest) return null;

      // DO NOT match if the clicked element or any ancestor is an Add to Cart button or component
      if (target.closest('button[name="add"], input[name="add"], .add-to-cart-button, [data-testid="standalone-add-to-cart"], [data-action="add-to-cart"], .quick-add__button, add-to-cart-component, sticky-add-to-cart, .sticky-add-to-cart')) {
        return null;
      }

      // ONLY match explicit checkout triggers
      var checkoutBtn = target.closest('button[name="checkout"], #checkout, .cart__checkout-button, a[href*="/checkout"], [data-checkout-trigger], .kk-checkout-trigger');
      if (checkoutBtn) {
        if (isAddButton(checkoutBtn)) return null;
        return checkoutBtn;
      }
      return null;
    };

    var handleTrigger = function(e) {
      var checkoutBtn = isCheckoutTrigger(e.target);
      if (checkoutBtn) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        openDrawer();
        return false;
      }
    };

    // Capture click and touch events on explicit checkout triggers
    document.addEventListener('click', handleTrigger, true);
    document.addEventListener('touchend', function(e) {
      var checkoutBtn = isCheckoutTrigger(e.target);
      if (checkoutBtn) {
        e.preventDefault();
        e.stopPropagation();
        openDrawer();
      }
    }, { capture: true, passive: false });

    // Intercept form submit targeting /checkout or cart form checkout submissions
    // CRITICAL FIX: "Add to Cart" (action="/cart/add", name="add") MUST NOT be intercepted!
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;

      var action = (form.getAttribute('action') || '').toLowerCase();
      var submitter = e.submitter;

      // 1. Explicitly ignore ANY Add to Cart form or submission
      if (action.indexOf('/cart/add') !== -1) {
        return; // Allow native theme Add to Cart to run completely untouched!
      }
      if (submitter && isAddButton(submitter)) {
        return; // Allow native theme Add to Cart to run completely untouched!
      }
      if (form.getAttribute('data-type') === 'add-to-cart-form' || (form.classList && form.classList.contains('shopify-product-form'))) {
        var isCheckoutBtn = submitter && (submitter.name === 'checkout' || submitter.id === 'checkout' || (submitter.classList && submitter.classList.contains('cart__checkout-button')));
        if (!isCheckoutBtn) {
          return;
        }
      }

      // 2. ONLY intercept forms targeting /checkout or cart forms submitted by checkout button
      var isCheckoutAction = action.indexOf('/checkout') !== -1;
      var isCheckoutSubmitter = submitter && (
        submitter.name === 'checkout' ||
        submitter.id === 'checkout' ||
        (submitter.classList && (submitter.classList.contains('cart__checkout-button') || submitter.classList.contains('kk-checkout-trigger')))
      );
      var isCartForm = (form.id === 'cart-form') || (action === '/cart') || (action === '/cart/');

      if (isCheckoutAction || (isCartForm && isCheckoutSubmitter)) {
        e.preventDefault();
        e.stopPropagation();
        openDrawer();
        return false;
      }
    }, true);

    // If customer navigates directly to /cart, convert checkout buttons
    if (window.location.pathname.toLowerCase().indexOf('/cart') !== -1) {
      var convertBtns = function() {
        var cartCheckoutBtns = document.querySelectorAll('button[name="checkout"], #checkout, .cart__checkout-button, .kk-checkout-trigger');
        cartCheckoutBtns.forEach(function(b) {
          if (isAddButton(b)) return;
          b.setAttribute('type', 'button');
          b.removeAttribute('form');
          b.onclick = function(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            openDrawer();
            return false;
          };
        });
      };
      convertBtns();
      setTimeout(convertBtns, 300);
      setTimeout(convertBtns, 1000);
    }
  }

  // Expose API for external triggers if needed
  window.KapadiaKraftCheckout = {
    open: openDrawer,
    close: closeDrawer,
    refreshCart: fetchCart
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCheckoutInterceptors);
  } else {
    initCheckoutInterceptors();
  }
})();
